import * as exchangeApi from '@/network/api/exchange.api.js'

/** requests exchange table list
@return { promise } - Exchange table request
*/
export const requestExchangeTableList = async (context, payload) => {
    const res = await exchangeApi.requestExchangeTableList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_EXCHANGE_TABLE_LIST', data)
    }
    return res
}

/** requests non authenticated exchange table list
@return { promise } - Exchange table request
*/
export const requestNonAuthenticatedExchangeTableList = async (context, payload) => {
    const res = await exchangeApi.requestNonAuthenticatedExchangeTableList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_EXCHANGE_TABLE_LIST', data)
    }
    return res
}

/** requests exchange table with value
@return { promise } - Exchange table with value request
*/
export const requestExchangeTableWithValue = async (context, payload) => {
    const res = await exchangeApi.requestExchangeTableWithValue(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_EXCHANGE_TABLE_WITH_VALUE', data)
    }
    return res
}

/** requests non authenticated exchange table with value
@return { promise } - Exchange table with value request
*/
export const requestNonAuthenticatedExchangeTableWithValue = async (context, payload) => {
    const res = await exchangeApi.requestNonAuthenticatedExchangeTableWithValue(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_EXCHANGE_TABLE_WITH_VALUE', data)
    }
    return res
}

/** Clears exchange table list */
export const clearExchangeTableList = (context, payload) => {
    context.commit('SAVE_EXCHANGE_TABLE_LIST', [])
}

/** Clears exchange table with value */
export const clearExchangeTableWithValue = (context, payload) => {
    context.commit('SAVE_EXCHANGE_TABLE_WITH_VALUE', [])
}
